module.exports = __webpack_public_path__ + "static/iphone-f58a37fb58cbb263bf7209adb6a2e05b.png";